{
  "familyId": "SWW-VD-HOMOFOON",
  "questions": [
    {
      "id": "SWW-VD-HOMOFOON-001",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "multiple_choice",
      "question": "Een journalist schrijft: 'Als ik het ... (weten), had ik het gezegd.' Welke werkwoordsvorm past?",
      "options": ["had geweten", "wist", "weet", "geweten"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Voltooid Verleden Tijd",
            "content": "Voltooid verleden tijd: had/was + voltooid deelwoord. Voorbeeld: had geweten, was gegaan. Gebruik deze tijd als iets in het verleden al klaar was vóór iets anders.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "all_tenses_mix",
      "variantIndex": 1,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "De journalist herkent: de zin beschrijft iets dat in het verleden had kunnen gebeuren ('Als ik het ..., had ik het gezegd'). Dit vraagt om voltooid verleden tijd: had + voltooid deelwoord. Het voltooid deelwoord van 'weten' is 'geweten'. Dus: had geweten.",
        "solutionSteps": [
          "De zin beschrijft iets in het verleden → voltooid verleden tijd",
          "Voltooid verleden tijd = had/was + voltooid deelwoord",
          "Voltooid deelwoord van 'weten' = geweten",
          "Antwoord: had geweten"
        ],
        "distractorExplanations": {
          "0": "Goed! Voltooid verleden tijd: had + voltooid deelwoord = had geweten.",
          "1": "Je dacht waarschijnlijk dat de gewone verleden tijd hier past. Maar 'wist' is de gewone verleden tijd. De constructie 'Als ik het ... had ik ...' vraagt om voltooid verleden tijd: had geweten. Onthoud: 'had ... had' = voltooid verleden tijd.",
          "2": "Je dacht waarschijnlijk dat de tegenwoordige tijd hier past. Maar 'weet' is tegenwoordige tijd, terwijl de zin het verleden beschrijft ('had ik het gezegd'). Onthoud: kijk naar de andere werkwoorden in de zin.",
          "3": "Je dacht waarschijnlijk dat 'geweten' alleen genoeg is. Maar de voltooid verleden tijd heeft altijd een hulpwerkwoord nodig: had geweten, niet alleen geweten. Onthoud: voltooid deelwoord gaat altijd samen met had/was."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.vvt-vt-confusion", "label": "Gewone verleden tijd i.p.v. voltooid verleden tijd", "optionIndex": 1 },
          { "id": "sww.tense-confusion-tt-vt", "label": "Tegenwoordige tijd gebruikt in verleden context", "optionIndex": 2 },
          { "id": "sww.vd-without-aux", "label": "Voltooid deelwoord zonder hulpwerkwoord", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-002",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "text_highlight",
      "question": "Lees beide zinsdelen goed. Welk werkwoord is fout? Let op: niet elke vorm zonder -t is verkeerd.",
      "context": "Ik word steeds sterker door te sporten en hij word dat ook.",
      "options": [],
      "correctAnswer": 1,
      "data": {
        "text": "Ik word steeds sterker door te sporten en hij word dat ook.",
        "correctHighlights": [{"start": 47, "end": 51}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Word vs. Wordt",
            "content": "Bij 'ik' gebruik je alleen de stam: ik word (zonder t). Bij hij/zij/het voeg je -t toe: hij wordt. Twee handige checks: (1) Smurfen: 'Ik smurf' (zonder -t) → ik word. 'Hij smurft' (met -t) → hij wordt. (2) Loop: 'ik loop' (zonder -t) → ik word. 'hij loopt' (met -t) → hij wordt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "word_wordt_ik_compare",
      "variantIndex": 2,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Twee keer staat er 'word' — maar maar één is fout. Eerste: 'Ik word' = correct (bij ik gebruik je de stam zonder -t). Tweede: 'hij word' = FOUT — bij hij voeg je altijd -t toe: hij wordt. Vergelijk de twee onderwerpen: ik krijgt geen -t, hij krijgt wel -t. Smurfen-check: 'Ik smurf' klinkt goed (= ik word ✓), 'hij smurft' klinkt goed (= hij wordt, dus 'hij word' is fout).",
        "solutionSteps": [
          "Vind beide werkwoord-vormen: 'Ik word' en 'hij word'",
          "Bepaal per zin het onderwerp: ik (1e p.) en hij (3e p.)",
          "Regel: ik = stam zonder -t, hij = stam + -t",
          "Eerste 'word' bij ik = correct ✓",
          "Tweede 'word' bij hij = fout → moet wordt zijn"
        ],
        "distractorExplanations": {
          "1": "Goed! De tweede 'word' (bij hij) is fout — moet wordt zijn. De eerste 'word' (bij ik) is wél correct."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.word-wordt-ik", "label": "Subject-verb mismatch: hij + stam zonder -t" }
        ]
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-003",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "text_highlight",
      "question": "Beide zinsdelen gaan over 'hij'. Welk werkwoord is fout gespeld?",
      "context": "Hij wordt steeds sterker door te sporten en daardoor word hij gezonder.",
      "options": [],
      "correctAnswer": 1,
      "data": {
        "text": "Hij wordt steeds sterker door te sporten en daardoor word hij gezonder.",
        "correctHighlights": [{"start": 53, "end": 57}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Word vs. Wordt — ook bij inversie",
            "content": "Bij hij/zij/het voeg je -t toe, óók als het werkwoord vóór het onderwerp staat: 'daardoor wordt hij'. Inversie verandert de regel niet.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "word_wordt_inversion_compare",
      "variantIndex": 3,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Beide werkwoorden horen bij 'hij' (3e persoon enkelvoud) en moeten dus stam + -t krijgen. Eerste: 'Hij wordt' = correct ✓. Tweede: 'daardoor word hij' = FOUT — ook bij inversie (werkwoord vóór onderwerp) blijft de regel gelden: 3e persoon krijgt -t, dus 'wordt hij'. De woordvolgorde verandert de regel niet. Smurfen-check: 'daardoor smurft hij' klinkt goed (met -t).",
        "solutionSteps": [
          "Vind beide werkwoorden: 'wordt' en 'word'",
          "Onderwerp van beide = hij (3e persoon enkelvoud)",
          "Regel: 3e persoon enkelvoud krijgt altijd -t, óók bij inversie",
          "Eerste 'wordt' = correct ✓",
          "Tweede 'word' = fout → bij inversie blijft regel: wordt hij"
        ],
        "distractorExplanations": {
          "1": "Goed! 'Word hij' is fout — ook bij inversie blijft de -t-regel: wordt hij. De eerste 'wordt' is wél correct."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.word-wordt-hij", "label": "Inversie genegeerd: -t weggelaten bij werkwoord-vóór-hij" }
        ]
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-004",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "text_highlight",
      "question": "In één zin staat 'word' fout, in de andere is het correct. Klik op de fout.",
      "context": "Het boek word morgen bezorgd. Ik word zenuwachtig van het wachten.",
      "options": [],
      "correctAnswer": 1,
      "data": {
        "text": "Het boek word morgen bezorgd. Ik word zenuwachtig van het wachten.",
        "correctHighlights": [{"start": 9, "end": 13}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Het onderwerp bepaalt de -t",
            "content": "Bij 'het' (3e persoon) voeg je -t toe: het wordt. Bij 'ik' (1e persoon) blijft de stam: ik word. Dezelfde stam, andere vorm — bepaal altijd eerst het onderwerp.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "word_wordt_het_vs_ik_compare",
      "variantIndex": 4,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Twee keer 'word' — maar het onderwerp bepaalt of er een -t bij hoort. Eerste: 'Het boek word' = FOUT — 'het boek' is 3e persoon enkelvoud, dus stam + -t = wordt. Tweede: 'Ik word' = correct ✓ — bij ik gebruik je de stam zonder -t. De regel hangt af van het onderwerp, niet van het woord zelf. Smurfen-check: 'het boek smurft' (met -t), 'ik smurf' (zonder -t).",
        "solutionSteps": [
          "Vind beide 'word'-vormen in de twee zinnen",
          "Bepaal per zin het onderwerp: 'het boek' (3e p.) en 'ik' (1e p.)",
          "Regel: het = stam + -t, ik = stam zonder -t",
          "Eerste 'word' bij het boek = fout → moet wordt zijn",
          "Tweede 'word' bij ik = correct ✓"
        ],
        "distractorExplanations": {
          "1": "Goed! 'Het boek word' is fout — moet wordt zijn. Bij 'ik word' is geen -t nodig."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.word-wordt-het", "label": "Subject-afhankelijke -t-regel niet toegepast bij het/ik-contrast" }
        ]
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-005",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "multiple_choice",
      "question": "Een advocaat schrijft een brief: 'De verdachte ... (worden) vrijgesproken door de rechter.' Welke vorm past?",
      "options": ["werd", "word", "wordt", "geworden"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verleden tijd van 'worden'",
            "content": "De verleden tijd van 'worden' is: ik/hij/zij werd, wij/zij werden. 'De verdachte' = hij/zij → werd. Let op: 'werd' (enkelvoud) vs. 'werden' (meervoud).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "worden_past_tense",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "De advocaat herkent: de zin beschrijft iets in het verleden (vrijgesproken door de rechter). 'De verdachte' = hij/zij → verleden tijd enkelvoud: werd. Niet 'word' (stam) of 'wordt' (tegenwoordige tijd).",
        "solutionSteps": [
          "De zin beschrijft het verleden → verleden tijd",
          "'De verdachte' = hij/zij → enkelvoud",
          "Verleden tijd enkelvoud van 'worden' = werd",
          "Antwoord: De verdachte werd vrijgesproken"
        ],
        "distractorExplanations": {
          "0": "Goed! De verleden tijd enkelvoud van 'worden' is 'werd'.",
          "1": "Je dacht waarschijnlijk dat de stam hier past. Maar 'word' is de stam (ik-vorm tegenwoordige tijd). De zin beschrijft het verleden, dus: werd. Onthoud: kijk of de zin over het verleden gaat.",
          "2": "Je dacht waarschijnlijk dat de tegenwoordige tijd hier past. Maar 'wordt' is tegenwoordige tijd. De zin beschrijft iets dat al gebeurd is (vrijgesproken), dus verleden tijd: werd. Onthoud: 'vrijgesproken' wijst op het verleden.",
          "3": "Je dacht waarschijnlijk dat het voltooid deelwoord hier past. Maar 'geworden' hoort bij 'is geworden'. Hier staat geen hulpwerkwoord 'is', dus gewoon verleden tijd: werd. Onthoud: voltooid deelwoord = altijd met hulpwerkwoord."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.tense-confusion-tt-vt", "label": "Tijdcontext genegeerd (stam i.p.v. VT)", "optionIndex": 1 },
          { "id": "sww.tense-confusion-tt-vt", "label": "TT (wordt) i.p.v. VT (werd) in verleden context", "optionIndex": 2 },
          { "id": "sww.vd-without-aux", "label": "Voltooid deelwoord zonder hulpwerkwoord", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-006",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "error_spotting",
      "question": "Zoek de fouten in deze tekst. Tik op een fout woord en typ de verbetering.",
      "options": [],
      "correctAnswer": null,
      "data": {
        "text": "De jongen word altijd opgehaald door zijn moeder. Gisteren heefd hij zelf gefietst. Hij vind dat veel leuker.",
        "errors": [
          { "word": "word", "position": 2, "correction": "wordt", "rule": "Tegenwoordige tijd, 3e persoon: stam + t (wordt)" },
          { "word": "heefd", "position": 10, "correction": "heeft", "rule": "Onregelmatig werkwoord hebben: hij heeft" },
          { "word": "vind", "position": 15, "correction": "vindt", "rule": "Tegenwoordige tijd, 3e persoon: stam + t (vindt)" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stam + t bij hij/zij/het",
            "content": "Bij hij, zij of het in de tegenwoordige tijd gebruik je altijd de stam + t. Dus: hij wordt, hij vindt. Ook als de stam al op een -d eindigt!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "homofoon_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Bij 'hij' of 'de jongen' gebruik je in de tegenwoordige tijd altijd de stam + t. Dus: hij wordt, hij vindt. Het werkwoord 'hebben' is onregelmatig: hij heeft (niet heefd).",
        "solutionSteps": [
          "De jongen (hij) + worden (tegenwoordige tijd) = wordt",
          "Hij + hebben = heeft",
          "Hij + vinden (tegenwoordige tijd) = vindt"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.stam-plus-t-vergeten", "label": "Stam + t vergeten bij 3e persoon enkelvoud" }
        ]
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-007",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "multiple_choice",
      "question": "De docent zegt tegen Tom: 'Jij ___ de twee woorden steeds.' Welke vorm past?",
      "options": ["verwart", "verward", "verwarrt", "verwarde"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verwart vs. verward",
            "content": "Verwarren is een zwak werkwoord. Tegenwoordige tijd 3e persoon enkelvoud (hij/zij/jij ná werkwoord): stam + t = verwar + t = verwart (met -t, geen -d). Voltooid deelwoord: ge- wegens be-/ver-/ont-/her-/er-/ge- (BEVO-HEG)? Ja, ver- → geen ge-. Kofschip: 'r' niet in kofschip → +d → verward (met -d). Korte check: kun je 'hij/zij/het' invullen + is het tegenwoordige tijd? → verwart (-t). Staat er een hulpwerkwoord (heeft/is) of een bijvoeglijk gebruik? → verward (-d).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verwart_verward_basic_mc",
      "variantIndex": 7,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De zin 'Jij verwart de twee woorden' is tegenwoordige tijd. Het onderwerp is 'jij' in gewone volgorde (niet inversie), dus de regel is: stam + t = verwart. Géén voltooid deelwoord — er staat geen hulpwerkwoord (heeft/is). Check: 'jij loopt' (stam + t) → 'jij verwart' (stam + t). De vorm 'verward' is het voltooid deelwoord en hoort bij een hulpwerkwoord ('hij is verward').",
        "solutionSteps": [
          "Bepaal de werkwoord-rol: is het persoonsvorm of voltooid deelwoord?",
          "Geen hulpwerkwoord (heeft/is) in de zin → persoonsvorm",
          "Onderwerp 'jij' in gewone volgorde → stam + t",
          "Stam van verwarren = verwar → verwar + t = verwart",
          "Antwoord: verwart (met -t)"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Jij verwart' — tegenwoordige tijd, stam + t = verwart.",
          "1": "Je koos het voltooid deelwoord. Maar 'verward' hoort bij een hulpwerkwoord ('hij is verward'). In deze zin staat geen hulpwerkwoord — het is gewone tegenwoordige tijd: verwart.",
          "2": "Je hebt 'verwarrt' met dubbele -r geschreven. Maar de stam van 'verwarren' is 'verwar' (één -r), dus stam + t = verwart. De dubbele -r hoort alleen bij het hele werkwoord (verwarren).",
          "3": "Je koos de verleden tijd ('hij verwarde'). Maar de zin is tegenwoordige tijd ('jij ... de twee woorden steeds') — er is geen tijdssignaal voor verleden. Antwoord: verwart."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.verwart-verward-vd-als-tt", "label": "VD-vorm (verward) gebruikt waar TT (verwart) hoort", "optionIndex": 1 },
          { "id": "sww.stem-with-extra-letter", "label": "Dubbele -r toegevoegd aan stam", "optionIndex": 2 },
          { "id": "sww.tense-confusion-tt-vt", "label": "VT gekozen in TT-context", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-008",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "text_highlight",
      "question": "Eén werkwoordsvorm is fout. Klik op de fout. Let op: verwart vs. verward.",
      "context": "Hij is helemaal verwart door de moeilijke uitleg van de juf.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Hij is helemaal verwart door de moeilijke uitleg van de juf.",
        "correctHighlights": [{"start": 17, "end": 24}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verward na 'is' / 'heeft'",
            "content": "Na een vorm van zijn (is, was, ben) of hebben (heeft, had) komt het voltooid deelwoord. Voltooid deelwoord van 'verwarren': ver- (BEVO-HEG) → geen extra ge-. Kofschip-check op stam 'verwar': 'r' niet in kofschip → +d. Dus: 'hij is verward' (met -d), niet 'verwart'.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verwart_verward_highlight_is",
      "variantIndex": 8,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het werkwoord 'is' is een hulpwerkwoord — daarna komt altijd het voltooid deelwoord, niet de persoonsvorm. Het VD van 'verwarren' is 'verward' (met -d, kofschip: r niet in kofschip → +d). 'Verwart' is fout: dat is de tegenwoordige-tijdvorm (stam + t), maar past hier niet — na 'is' hoort 'verward'. Check: 'hij is gelopen', 'hij is verward' — beide VD na is/heeft.",
        "solutionSteps": [
          "Zoek het hulpwerkwoord: 'is' → wijst op voltooid deelwoord",
          "Bepaal VD van verwarren: ver- (BEVO-HEG) → geen ge-",
          "Kofschip-check op stam 'verwar': r niet in kofschip → +d",
          "Correct: 'hij is verward' (met -d)",
          "'Verwart' (met -t) is fout — dat is tegenwoordige tijd, niet VD"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Verwart' is fout na 'is' — hier hoort het voltooid deelwoord 'verward' (met -d)."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.verwart-verward-tt-vd", "label": "TT-vorm (verwart) gebruikt waar VD (verward) hoort" }
        ]
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-009",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "fill_in",
      "question": "Vul de juiste vorm in (verwart of verward): 'De lerares ___ de woorden 'lenen' en 'huren' soms nog.' Let op: kijk wat het onderwerp en de tijd zijn.",
      "correctAnswer": "verwart",
      "data": {
        "acceptedAnswers": ["verwart"],
        "placeholder": "verwart of verward?",
        "inputType": "text"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "2-stappen-check voor verwart/verward",
            "content": "Stap 1: staat er een hulpwerkwoord (is/was/heeft/had/wordt)? → Ja → voltooid deelwoord 'verward' (met -d). Nee → ga naar stap 2. Stap 2: tegenwoordige tijd met hij/zij/het of jij in gewone volgorde → stam + t = 'verwart' (met -t). Hier: geen hulpwerkwoord, onderwerp 'de lerares' (3e p. enkelvoud), tegenwoordige tijd → verwart.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verwart_verward_fill_in_subject",
      "variantIndex": 9,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Loop de 2-stappen-check af. Stap 1: is er een hulpwerkwoord (is/heeft/wordt)? Nee — er staat alleen 'de lerares ___ de woorden'. → Geen voltooid deelwoord. Stap 2: tegenwoordige tijd, onderwerp 'de lerares' (3e persoon enkelvoud) → stam + t = verwar + t = verwart (met -t). Check: 'de lerares loopt' (stam + t) → 'de lerares verwart' (stam + t). Niet 'verward' — dat zou alleen kloppen mét hulpwerkwoord ('de lerares is verward').",
        "solutionSteps": [
          "Stap 1 — Hulpwerkwoord (is/heeft/wordt)? Nee → geen VD",
          "Stap 2 — Tegenwoordige tijd, onderwerp = de lerares (3e p. enkelvoud)",
          "Regel: 3e persoon enkelvoud TT → stam + t",
          "Stam van verwarren = verwar",
          "Antwoord: verwar + t = verwart"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.verwart-verward-vd-als-tt", "label": "VD-vorm (verward) gebruikt waar TT (verwart) hoort" }
        ]
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-010",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "error_spotting",
      "question": "Zoek de werkwoordspellingfouten in deze tekst. Let op verwart vs. verward en op de andere homofonen.",
      "correctAnswer": null,
      "data": {
        "text": "De leraar verward de leerlingen vaak met zijn uitleg. Daardoor is de hele klas verwart geraakt. Maar Tom word nooit boos op de leraar.",
        "errors": [
          { "word": "verward", "correction": "verwart", "startIndex": 10, "endIndex": 17, "explanation": "Tegenwoordige tijd, onderwerp 'de leraar' (3e p. enkelvoud), geen hulpwerkwoord → stam + t = verwart (met -t)." },
          { "word": "verwart", "correction": "verward", "startIndex": 73, "endIndex": 80, "explanation": "Na 'is ... geraakt' hoort het voltooid deelwoord. VD van verwarren: ver- = geen ge-, r niet in kofschip → +d → verward (met -d)." },
          { "word": "word", "correction": "wordt", "startIndex": 110, "endIndex": 114, "explanation": "Onderwerp 'Tom' (3e p. enkelvoud) in tegenwoordige tijd → stam + t = wordt (met -t)." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Homofoon-check voor verwart/verward",
            "content": "1) Hulpwerkwoord (is/heeft/wordt) in de buurt? → VD: verward (-d). 2) Geen hulpwerkwoord, 3e p. of jij in gewone volgorde? → TT: verwart (-t). Zelfde principe als word/wordt en vind/vindt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "verwart_verward_error_spotting_mixed",
      "variantIndex": 10,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Drie fouten in de tekst, alle gebaseerd op dezelfde regel: 3e persoon enkelvoud TT = stam + t; VD na hulpwerkwoord = stam + d (volgens kofschip). Fout 1: 'De leraar verward' — geen hulpwerkwoord, TT, 3e p. → moet verwart zijn. Fout 2: 'is de klas verwart geraakt' — 'is ... geraakt' is voltooide tijd, en 'verwart' hier is een bijvoeglijk VD → moet verward zijn. Fout 3: 'Tom word' — 3e p. enkelvoud TT → moet wordt zijn. De homofoon-paren verwart/verward en word/wordt volgen exact dezelfde logica: onderwerp + tijd bepalen, dan stam + t of stam + d.",
        "solutionSteps": [
          "Voor elk werkwoord: zoek het onderwerp en check op hulpwerkwoord",
          "'De leraar verward' → geen hulpwerkwoord, TT, hij → verwart (stam + t)",
          "'is ... verwart geraakt' → 'is' is hulpwerkwoord, bijvoeglijk VD → verward (stam + d)",
          "'Tom word' → geen hulpwerkwoord, TT, hij → wordt (stam + t)",
          "Patroon: TT 3e p. = stam + t; VD na hulpwerkwoord = stam + d"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.verwart-verward-vd-als-tt", "label": "VD-vorm (verward) gebruikt waar TT (verwart) hoort" },
          { "id": "sww.verwart-verward-tt-vd", "label": "TT-vorm (verwart) gebruikt waar VD (verward) hoort" },
          { "id": "sww.stam-plus-t-vergeten", "label": "Stam + t vergeten bij 3e persoon enkelvoud (word i.p.v. wordt)" }
        ]
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-011",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "error_spotting",
      "question": "Vind de werkwoordspellingfouten in deze tekst. Let op: word/wordt, vind/vindt, verwart/verward.",
      "correctAnswer": null,
      "data": {
        "text": "Hij word steeds beter in spelling. Ze heeft het antwoord al gevonden, maar ze vind het moeilijk om uit te leggen. Het probleem wordt nu opgelost.",
        "errors": [
          { "word": "word", "correction": "wordt", "startIndex": 3, "endIndex": 7, "explanation": "Bij 'hij' in de tegenwoordige tijd: stam + t. Word + t = wordt." },
          { "word": "vind", "correction": "vindt", "startIndex": 86, "endIndex": 90, "explanation": "Bij 'ze' (enkelvoud) in de tegenwoordige tijd: stam + t. Vind + t = vindt." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Homofonen: word/wordt, vind/vindt", "content": "Ik word (geen t), hij/zij wordt (wel t). Ik vind (geen t), hij/zij vindt (wel t). Check: vervang door een ander werkwoord. 'Hij loop' klinkt fout → 'hij loopt' → dus ook 'hij wordt'.", "icon": "lightbulb" } }
      ],
      "conceptId": "homofoon_error_spotting",
      "variantIndex": 11,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Twee fouten: 1) 'Hij word' → 'Hij wordt' (hij + stam + t). 2) 'ze vind' → 'ze vindt' (zij + stam + t). De laatste zin is correct: 'Het probleem wordt' (het + stam + t).",
        "solutionSteps": [
          "Check elk werkwoord: wie is het onderwerp?",
          "'Hij word' → hij = 3e persoon → wordt (stam + t)",
          "'ze vind' → zij = 3e persoon → vindt (stam + t)"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.stam-plus-t-vergeten", "label": "Stam-t vergeten in tegenwoordige tijd 3e persoon" }
        ]
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-012",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "fill_in",
      "question": "Vul de juiste vorm in de tegenwoordige tijd in: 'Het boek dat ik gisteren heb besteld, ___ (worden) morgen bezorgd.' Let op: kijk goed wat het onderwerp is.",
      "correctAnswer": "wordt",
      "data": {
        "acceptedAnswers": ["wordt"],
        "placeholder": "word of wordt?",
        "inputType": "text"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Onderwerp vinden in een lange zin", "content": "Bij een zin met een bijzin (zoals 'dat ik gisteren heb besteld') zit het echte onderwerp vóór die bijzin. Lees de zin zonder de bijzin: 'Het boek ___ morgen bezorgd.' Onderwerp = het boek (3e p.) → stam + t = wordt.", "icon": "lightbulb" } }
      ],
      "conceptId": "homofoon_fill_in_subject_distance",
      "variantIndex": 12,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De bijzin 'dat ik gisteren heb besteld' is een afleider — daarin staat 'ik', maar dat is NIET het onderwerp van het hoofdwerkwoord. Lees de zin zonder de bijzin: 'Het boek ___ morgen bezorgd.' Het echte onderwerp is 'het boek' (3e persoon enkelvoud). Bij hij/zij/het: stam + -t = wordt. Handige tip: zet altijd haakjes om de bijzin om de hoofdzin overzichtelijk te maken.",
        "solutionSteps": [
          "Lees de hele zin en zoek de bijzin tussen komma's: 'dat ik gisteren heb besteld'",
          "Haal de bijzin weg: 'Het boek ___ morgen bezorgd.'",
          "Echte onderwerp = 'het boek' (3e persoon enkelvoud, niet 'ik')",
          "Regel: 3e persoon TT → stam + -t = wordt",
          "Antwoord: wordt"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.word-wordt-het", "label": "Bijzin-afleider gevolgd: 'ik' uit bijzin als onderwerp gekozen" }
        ]
      }
    }
  ]
}